import React from 'react'
import Header from '@components/Header/Header'
import BottomNavBar from '@/components/BottomNavBar/BottomNavBar'
import styles from './PageLayout.module.scss'

type PageLayoutProps = {
  children: React.ReactNode
}

function PageLayout({ children }: PageLayoutProps) {
  return (
    <div className={styles.protectedPageLayout}>
      <Header />
      {children}
      <BottomNavBar />
    </div>
  )
}

export default PageLayout
